var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { Carousel } from '@trendyol-js/react-carousel';
import OrganizationDeveloperPlanCard from './OrganizationDeveloperPlanCard';
import { CarouselIcon, CarouselIconWrapper } from './styles';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons/faChevronRight';
import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons/faChevronLeft';
import { useWindowDimensions } from '../../utils/hooks/dimensions';
var CarouselMonthly = function (_a) {
    var developerPlans = _a.developerPlans, devPlanStatus = _a.devPlanStatus, onSubscribeButtonClick = _a.onSubscribeButtonClick, loading = _a.loading;
    var _b = useState(1), show = _b[0], setShow = _b[1];
    var width = useWindowDimensions().width;
    width < 860
        ? show !== 1 && setShow(1)
        : width < 1010
            ? show !== 1.5 && setShow(1.5)
            : width < 1160
                ? show !== 2 && setShow(2)
                : width < 1310
                    ? show !== 2.5 && setShow(2.5)
                    : width < 1520
                        ? show !== 3 && setShow(3)
                        : width < 1610
                            ? show !== 3.5 && setShow(3.5)
                            : width < 1760
                                ? show !== 4 && setShow(4)
                                : width < 1910
                                    ? show !== 4.5 && setShow(4.5)
                                    : width < 2060
                                        ? show !== 5 && setShow(5)
                                        : width < 2210
                                            ? show !== 5.5 && setShow(5.5)
                                            : width < 2360
                                                ? show !== 6 && setShow(6)
                                                : width < 2510
                                                    ? show !== 6.5 && setShow(6.5)
                                                    : width < 2660
                                                        ? show !== 7 && setShow(7)
                                                        : show !== 8 && setShow(8);
    return (_jsx(Carousel, __assign({ show: show, slide: 1, swiping: true, useArrowKeys: true, infinite: false, rightArrow: _jsx(CarouselIconWrapper, { children: _jsx(CarouselIcon, { icon: faChevronRight }) }), leftArrow: _jsx(CarouselIconWrapper, { children: _jsx(CarouselIcon, { icon: faChevronLeft }) }), dynamic: true }, { children: developerPlans.map(function (plan) { return (_jsx(OrganizationDeveloperPlanCard, { data: plan, devPlanStatus: devPlanStatus, onSubscribeButtonClick: onSubscribeButtonClick, loading: loading }, plan.id)); }) })));
};
export default CarouselMonthly;
